<template>
  <div>
    <div class="columns" v-if="data.length >= 1">
      <div class="column">
        <rv-year name="outgoing-fee-from-year-0" label="From year" v-model="data.list[0].fromYear" v-on:input="update" :validation-rule="validationRule.fromYear"/>
      </div>
      <div class="column">
        <rv-year name="outgoing-fee-to-year-0" label="To year" v-model="data.list[0].toYear" v-on:input="update" :validation-rule="validationRule.toYear"/>
      </div>
      <div class="column">
        <rv-percentage name="outgoing-fee-rate-0" label="Outgoing fee percentage p.a." v-model="data.list[0].rate" v-on:input="update" :validation-rule="validationRule.rate" tooltip="It may be 6% annually for a period of at most the first 5 years. Or it may be at 10% annually for
at most the first 2 years followed by 2% annually for at most the next 5 years. Various other fee
structures may apply, where the annual fee rate varies over different periods."/>
      </div>
    </div>

    <div class="columns" v-if="data.length >= 2">
      <div class="column">
        <rv-year name="outgoing-fee-from-year-1" label="From year" v-model="data.list[1].fromYear" v-on:input="update" :validation-rule="validationRule.fromYear"/>
      </div>
      <div class="column">
        <rv-year name="outgoing-fee-to-year-1" label="To year" v-model="data.list[1].toYear" v-on:input="update" :validation-rule="validationRule.toYear"/>
      </div>
      <div class="column">
        <rv-percentage name="outgoing-fee-rate-1" label="Outgoing/exit fee percentage p.a." v-model="data.list[1].rate" v-on:input="update" :validation-rule="validationRule.rate"/>
      </div>
    </div>

    <div class="columns" v-if="data.length >= 3">
      <div class="column">
        <rv-year name="outgoing-fee-from-year-2" label="From year" v-model="data.list[2].fromYear" v-on:input="update" :validation-rule="validationRule.fromYear"/>
      </div>
      <div class="column">
        <rv-year name="outgoing-fee-to-year-2" label="To year" v-model="data.list[2].toYear" v-on:input="update" :validation-rule="validationRule.toYear"/>
      </div>
      <div class="column">
        <rv-percentage name="outgoing-fee-rate-2" label="Outgoing/exit fee percentage p.a." v-model="data.list[2].rate" v-on:input="update" :validation-rule="validationRule.rate"/>
      </div>
    </div>

    <div class="columns" v-if="data.length >= 4">
      <div class="column">
        <rv-year name="outgoing-fee-from-year-3" label="From year" v-model="data.list[3].fromYear" v-on:input="update" :validation-rule="validationRule.fromYear"/>
      </div>
      <div class="column">
        <rv-year name="outgoing-fee-to-year-3" label="To year" v-model="data.list[3].toYear" v-on:input="update" :validation-rule="validationRule.toYear"/>
      </div>
      <div class="column">
        <rv-percentage name="outgoing-fee-rate-3" label="Outgoing/exit fee percentage p.a." v-model="data.list[3].rate" v-on:input="update" :validation-rule="validationRule.rate"/>
      </div>
    </div>

    <div class="columns" v-if="data.length >= 5">
      <div class="column">
        <rv-year name="outgoing-fee-from-year-4" label="From year" v-model="data.list[4].fromYear" v-on:input="update" :validation-rule="validationRule.fromYear"/>
      </div>
      <div class="column">
        <rv-year name="outgoing-fee-to-year-4" label="To year" v-model="data.list[4].toYear" v-on:input="update" :validation-rule="validationRule.toYear"/>
      </div>
      <div class="column">
        <rv-percentage name="outgoing-fee-rate-4" label="Outgoing/exit fee percentage p.a." v-model="data.list[4].rate" v-on:input="update" :validation-rule="validationRule.rate"/>
      </div>
    </div>

    <button class="button is-primary is-outlined" v-on:click="addPeriod" v-if="data.length < 5">Add Period</button>
    <button class="button is-primary is-outlined" v-on:click="removePeriod" v-if="data.length > 1">Remove Period</button>
  </div>
</template>

<script>
import RvPercentage from '../RvPercentage'
import RvYear from '../RvYear'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    RvYear,
    RvPercentage
  },
  data() {
    return {
      validationRule: {
        rate: {
          required: true,
          between: [0, 100]
        },
        fromYear: {
          required: true,
          between: [1, 20]
        },
        toYear: {
          required: true,
          between: [1, 20]
        }
      },
      data: {
        length: this.value.length,
        list: this.value.list
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    },
    addPeriod: function() {
      if (this.data.length > 0 && this.data.length < 5) {
        this.data.length += 1
      }
      this.update()
    },
    removePeriod: function() {
      if (this.data.length > 1) {
        this.data.length -= 1
      }
      this.update()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/outgoing-fees/OutgoingFee.vue